<template>
    <div>
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane :label="this.$t('carsmanage.title1')" name="first"><CarData></CarData></el-tab-pane>
			<el-tab-pane :label="this.$t('carsmanage.title2')" name="second"><CarBrand></CarBrand></el-tab-pane>
		</el-tabs>
    </div>
</template>

<script>
	import CarData from '../../components/pages/carManage/CarData.vue';
	import CarBrand from '../../components/pages/carManage/CarBrand.vue';
    export default {
        name: "Admin",
		components:{
			CarData,
			CarBrand
		},
        data() {
            return {
				activeName: 'first'
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style scoped>
    
</style>
